import makeStyles from '@mui/styles/makeStyles';

const muiCheckboxStyles = makeStyles({
  formLabel: {
    color: 'var(--alt-black)',
    '& .MuiFormLabel-asterisk': {
      color: 'var(--error-color)', 
    },
  },
  checkboxLabel: {
    color: 'var(--alt-black)',
    '&:hover': {
      color: 'var(--primary-color)', // hover color for label
    },
    // Do not apply hover style when the parent is disabled
    '.Mui-disabled + &': {
    color: 'var(--alt-black)', // 
    },
  },
  checkboxRoot: {
    color: 'var(--dark-gray)', // default
    // target input focus to style the parent
    '&.Mui-focusVisible': {
      outline: '3px solid var(--accent-primary-color)',
      outlineOffset: '-5px',
    },
    '&:hover': {
      color: 'var(--primary-color)', // hover color
    },
  },
  checkboxSelected: {
    color: 'var(--primary-color) !important', // selected
    '&.Mui-focusVisible': {
      outline: '3px solid var(--accent-primary-color)',
              outlineOffset: '-5px',
    },
  },
  checkboxFocus: {
    outline: '3px solid var(--accent-primary-color)', // Custom focus indicator
    outlineOffset: '-5px',
  },
});

export default muiCheckboxStyles;